import { firstValueFrom } from 'rxjs';
import { TemplateControl } from '../request-result-modal.types';
import { FieldService } from '@6grain/masofa-monolith-api-client/crop-monitoring';
import { UserService } from '@6grain/masofa-monolith-api-client/identity';
import { userNames } from '@app/utils/_msf';

/**
 * Service class for enriching template controls with additional data
 */
export class ControlEnricher {
  constructor(
    private fieldService: FieldService,
    private userService: UserService
  ) {}

  /**
   * Enrich a single control with additional data based on its type
   */
  async enrichControl(control: TemplateControl): Promise<void> {
    if (control.name === 'field') {
      await this.enrichFieldControl(control);
    } else if (control.name === 'user') {
      await this.enrichUserControl(control);
    }
  }

  /**
   * Enrich field control with field name data
   */
  private async enrichFieldControl(control: TemplateControl): Promise<void> {
    const fieldId = control.values_ru || control.values_en || control.values_uz;

    if (!fieldId || fieldId === '' || fieldId === '00000000-0000-0000-0000-000000000000') {
      this.setControlValuesToDefault(control);
      return;
    }

    try {
      const field = await firstValueFrom(
        this.fieldService.cropMonitoringFieldGetByIdIdGet(fieldId)
      );

      if (field) {
        const f: any = field as any;
        control.values_en = (f.name_en as string) || (f.name as string) || '';
        control.values_ru = (f.name_ru as string) || (f.name as string) || '';
        control.values_uz = (f.name_uz as string) || (f.name as string) || '';
      } else {
        this.setControlValuesToDefault(control);
      }
    } catch (error) {
      console.error('Error fetching field:', error);
      this.setControlValuesToDefault(control);
    }
  }

  /**
   * Enrich user control with user name data
   */
  private async enrichUserControl(control: TemplateControl): Promise<void> {
    const userId = control.values_ru || control.values_en || control.values_uz;

    if (!userId || userId === '' || userId === '00000000-0000-0000-0000-000000000000') {
      this.setControlValuesToDefault(control);
      return;
    }

    try {
      const fieldWorker = await firstValueFrom(
        this.userService.identityUserGetByIdIdGet(userId)
      );

      if (fieldWorker) {
        const formattedName = userNames(fieldWorker);
        control.values_en = formattedName;
        control.values_ru = formattedName;
        control.values_uz = formattedName;
      } else {
        this.setControlValuesToDefault(control);
      }
    } catch (error) {
      console.error('Error fetching user:', error);
      this.setControlValuesToDefault(control);
    }
  }

  /**
   * Set control values to default '-' value
   */
  private setControlValuesToDefault(control: TemplateControl): void {
    control.values_en = '-';
    control.values_ru = '-';
    control.values_uz = '-';
  }
}

